import * as React from "react"
import { OverlayNoPresentImageProps } from "./custom-player.interface"
import { Box, Image } from "@chakra-ui/react"
import layoutStates from "../../../recoil/atoms/layout"
import { useRecoilState } from "recoil"

const _OverlayNoPresentImage: React.FC<OverlayNoPresentImageProps> = ({
  isMobile,
  wpSrc,
  watchPartyHostId,
  isTouchDelay,
  alertBackgroundColor,
  toggleShowLeaveOverlay,
  handleTouchStart,
  toggleShowLeaveOverlayTouchEnd
}): JSX.Element => {
  const [recordingView] = useRecoilState(layoutStates.recordingView)
  const modNotPresentOverlay =  watchPartyHostId === "modNotPresentOverlay" || wpSrc === "noSource"

  if(modNotPresentOverlay) {
    return (
      <Box
        id="noModPresentImage"
        borderRadius={!isMobile && !recordingView && "0.375rem"}
        width="100%"
        height="100%"
        backgroundColor={alertBackgroundColor}
        onClick={toggleShowLeaveOverlay}
        onTouchStart={!isTouchDelay ? handleTouchStart : null}
        onTouchEnd={!isTouchDelay ? toggleShowLeaveOverlayTouchEnd : null}
      />
    )
  }

  return (
    <Image
      id="noModPresentImage"
      objectFit={isMobile ? "cover" : "fill"}
      borderRadius={!isMobile && !recordingView && "0.375rem"}
      width="100%"
      height="100%"
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
      backgroundColor={
        watchPartyHostId === "modNotPresentOverlay"
          ? alertBackgroundColor
          : "transparent"
      }
      onClick={toggleShowLeaveOverlay}
      onTouchStart={!isTouchDelay ? handleTouchStart : null}
      onTouchEnd={!isTouchDelay ? toggleShowLeaveOverlayTouchEnd : null}
      src={wpSrc}
    />
  )
}

export const OverlayNoPresentImage = React.memo(_OverlayNoPresentImage)
